import 'features/errors/components/Error/Error.scss';
import ErrorReport from "features/errors/components/ErrorReport/ErrorReport";
import ErrorOldBrowser from "features/errors/components/ErrorOldBrowser/ErrorOldBrowser";

function Error({ level, error }) {
  const isIE = /*@cc_on!@*/false || !!document.documentMode;
  const mail = 'trefpunt@anbo-pcob.nl';
  const phone = '0348 - 23 86 77';

  return (
    <div className={ `content-container` }>
      <div className={ `error wrapper--fluid` }>
        {
          isIE ?
            <ErrorOldBrowser/>
            :
            <ErrorReport error={ error } level={ level } mail={ mail } phone={ phone }/>
        }
      </div>
    </div>
  )
}

export default Error;
